import {createStore, applyMiddleware, compose} from 'redux';
import {responsiveStoreEnhancer} from 'redux-responsive';
import {logger, thunk} from '../middleware';
import rootReducer from '../reducers';

export default function configure(initialState) {
	
	const store = createStore(
		rootReducer,
		initialState,
		compose(
			responsiveStoreEnhancer,
			applyMiddleware(logger, thunk),
			window.devToolsExtension ? window.devToolsExtension() : f => f
		)
	);
	return store;
}



// WEBPACK FOOTER //
// ./store/index.js